import { useState } from "react";
import { useLocation } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { guideFor } from "@/lib/pageGuide";

// Header button: opens a side panel explaining the current page section by section.
export const ExplainPage = ({ compact = false }) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const g = guideFor(pathname);
  if (!g) return null;
  return (
    <>
      <button data-testid="explain-page-btn" onClick={() => setOpen(true)} aria-label="Explain this page"
              className="btn-ghost rounded-lg px-2.5 py-2 text-xs font-medium inline-flex items-center gap-1.5 border border-slate-800 hover:border-cyan-900/60 shrink-0">
        <HelpCircle className="w-4 h-4 text-cyan-300" />{!compact && <span className="hidden xl:inline">Explain this page</span>}
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-[92vw] sm:max-w-md bg-[#0F141C] border-slate-800 text-slate-100 overflow-y-auto" data-testid="explain-page-sheet">
          <SheetHeader><SheetTitle className="font-display">Explain this page: {g.title}</SheetTitle><SheetDescription className="text-slate-300">{g.intro}</SheetDescription></SheetHeader>
          <div className="mt-4 space-y-3">
            {g.sections.map(([h, b], i) => (
              <div key={h} className="rounded-lg border border-slate-800 bg-slate-900/60 p-3" data-testid={`explain-section-${i}`}>
                <div className="text-sm font-medium text-cyan-200">{h}</div><div className="text-xs text-slate-300 mt-1 leading-relaxed">{b}</div>
              </div>
            ))}
            {g.next && <div className="rounded-lg border border-cyan-900/50 bg-cyan-500/5 p-3 text-xs text-slate-200" data-testid="explain-next"><strong className="text-cyan-200">What to do next:</strong> {g.next}</div>}
            <div className="text-[11px] text-slate-500">Everything in EV-IDEX is educational information, not financial advice. Predictions can be wrong; past results don't guarantee the future. Tap any ⓘ for a term's full explanation, or visit <a href="/learn" className="text-cyan-300 underline">Learn Crypto</a>.</div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
